"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _facebook = require("./../../icons/facebook.svg");
var _twitterX = require("./../../icons/twitter-x.svg");
var _SocialShareButtons = _interopRequireDefault(require("./../buttons/SocialShareButtons"));
var _helpers = require("../../utils/helpers");
var _SocialShareBlockModule = _interopRequireDefault(require("./../../scss/blocks/SocialShareBlock.module.scss"));
function SocialShareBlock(_ref) {
  let {
    url,
    text,
    longtext,
    showHeader = false,
    headerText = 'Share',
    iconSize = '1.5rem'
  } = _ref;
  const socailShareButtons = [{
    network: 'Facebook',
    icon: _facebook.ReactComponent
  }, {
    network: 'Twitter',
    icon: _twitterX.ReactComponent
  }];
  return /*#__PURE__*/_react.default.createElement("social-share", {
    class: _SocialShareBlockModule.default['social-share']
  }, showHeader && /*#__PURE__*/_react.default.createElement("h5", {
    className: "social-share__header"
  }, headerText, ":"), socailShareButtons.map(button => {
    const {
      network,
      icon: Icon
    } = button;
    return /*#__PURE__*/_react.default.createElement(_SocialShareButtons.default, {
      key: "social-share-".concat(network),
      network: network,
      url: url,
      text: text,
      longtext: longtext,
      title: "Share on ".concat(network)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: (0, _helpers.classes)(['social-share__icon', _SocialShareBlockModule.default['social-share__icon'], "social-share__icon--".concat(network), _SocialShareBlockModule.default["social-share__icon--".concat(network)]])
    }, /*#__PURE__*/_react.default.createElement(Icon, {
      width: iconSize,
      height: iconSize
    })));
  }));
}
var _default = exports.default = SocialShareBlock;